export default __webpack_public_path__ + "static/media/Group8418.5f33fa1f.svg";